module.exports = {
  title: '待清洗数据详情',
  route: {
    path: '/seller-goods-manage',
    children: {
      path: 'wait-clean-data-details',
    },
  },
};
